import React from "react";
import ScreeningDuplicate from "./../../Components/screeningComponent/screeningduplicate";
import { SnackbarProvider } from "notistack";
function ScreeningDuplicatePage() {
  return (
    <SnackbarProvider>
      <ScreeningDuplicate />
    </SnackbarProvider>
  );
}

export default ScreeningDuplicatePage;
